/**
 * Utility to encode and decode flight and search IDs for URL routes
 * using encodeURIComponent and decodeURIComponent.
 */

export function encodeFlightId(id: string | number): string {
  if (!id) return "";
  return encodeURIComponent(String(id).trim());
}

export function decodeFlightId(encodedId: string): string {
  if (!encodedId) return "";
  try {
    return decodeURIComponent(String(encodedId).trim());
  } catch {
    return String(encodedId);
  }
}
